<script>
  import { Router, Link, Route } from "svelte-routing";

  import Home from "./views/Home.svelte";
  import Login from "./views/Login.svelte";
  import Dash from "./views/Dash.svelte";
  // Prefijo de ruta tomado de la variable de entorno
  const basePath = __BASE_PATH__;
  console.log(basePath);
</script>

<div>
  <Router>
    <ul class="nav nav-underline justify-content-center">
      <li class="nav-item">
        <Link class="nav-link" to="{basePath}/">Home</Link>
      </li>
      <li class="nav-item">
        <Link class="nav-link" to="{basePath}/login">Login</Link>
      </li>
      <li class="nav-item">
        <Link class="nav-link" to="{basePath}/dashboard">Perfil</Link>
      </li>
    </ul>
    <hr />
    <Route path="/">
      <Home></Home>
    </Route>
    <Route path="/login">
      <Login></Login>
    </Route>
    <Route path="/dashboard">
      <Dash></Dash>
    </Route>
  </Router>
</div>
